import Splide from 'splide';

window.addEventListener('DOMContentLoaded', function(){
    setGnav();
    if(document.querySelectorAll(".mainvis").length!=0){
        setMvCal();
    }
    if(document.querySelectorAll(".products").length!=0){
        setPrdCal();
    }
    if(document.querySelectorAll("#movWrap").length!=0){
        setMov();
    }
    
    
    document.querySelector("#menu-btn-check").checked = false;
    setInstagram();
    //initCar();
});

const setInstagram=()=>{
    const InsSect=document.querySelectorAll(".insta");
    InsSect.forEach((i)=>{
        const incBt=i.querySelector("ul.isBts li.inc a");
        const decBt=i.querySelector("ul.isBts li.dec a");
        const insUnits=i.querySelectorAll(".instaOverWrap");
        let nowAct=0;

        if(insUnits.length>1){
            incBt.addEventListener('click',function(e){
                e.preventDefault();
                nowAct++;
                insUnits[nowAct].classList.add('active');
                jgBts();
            });
            decBt.addEventListener('click',function(e){
                e.preventDefault();
                insUnits[nowAct].classList.remove('active');
                nowAct--;
                jgBts();
            });
            const jgBts=function(){
                if(nowAct>=insUnits.length-1){
                    decBt.closest('li').classList.add('active');
                    incBt.closest('li').classList.remove('active');
                }else if(nowAct>0 && nowAct<insUnits.length-1){
                    incBt.closest('li').classList.add('active');
                    decBt.closest('li').classList.add('active');
                }else if(nowAct==0){
                    incBt.closest('li').classList.add('active');
                    decBt.closest('li').classList.remove('active');
                }
            };
        }else{
            incBt.remove();
            decBt.remove();
        }
        
    });

}

/*
const setInstagram_old=()=>{
    const insWrap=document.querySelectorAll(".insta");
    const liCnt=[];
    insWrap.forEach((i)=>{
        const iUl=i.querySelector("ul.instaList");
        const iLi=iUl.querySelectorAll("li");
        const incBt=i.querySelector("ul.isBts li.inc");
        const decBt=i.querySelector("ul.isBts li.dec");
        const unitViw=15//単位枠の表示セル数
        let iLiCnt=0;
        if(iLi.length>unitViw){
            iLiCnt=unitViw;
            incBt.classList.add('active');
        }else{
            iLiCnt=iLi.length;
        }

        const liDat={'total':iLi.length,'nowViw':iLiCnt};

        liCnt.push(liDat);
        for(let L=0;L<iLiCnt;L++){
            iLi[L].classList.add('active');
        }

        incBt.addEventListener('click',function(e){
            e.preventDefault();
            const oldLists=liDat.nowViw;
            if(oldLists+unitViw>liDat.total){
                liDat.nowViw=liDat.total;
            }else{
                liDat.nowViw+=unitViw;
            }
            
            for(let l=oldLists;l<liDat.nowViw;l++){
                iLi[l].classList.add('active');
            }
            
           jgBts();
        });

        decBt.addEventListener('click',function(e){
            e.preventDefault();
            const oldLists=liDat.nowViw;
            if(oldLists - unitViw < unitViw){
                liDat.nowViw=unitViw;
            }else{
                liDat.nowViw-=unitViw;
            }

            for(let l=oldLists-1;l>=liDat.nowViw;l--){
                iLi[l].classList.remove('active');
            }
            jgBts();
        });

        const jgBts=function(){
            if(liDat.nowViw<=unitViw){
                decBt.classList.remove('active');
                incBt.classList.add('active');
            }else if(liDat.nowViw>unitViw && liDat.nowViw<liDat.total){
                decBt.classList.add('active');
                incBt.classList.add('active');
            }else{
                decBt.classList.add('active');
                incBt.classList.remove('active');
            }
        }
    });
}
*/

const setGnav=()=>{
    const navCheck=document.getElementById("menu-btn-check");
    const mainNav=document.querySelectorAll("header>nav ul.mainNav li a.scroll");
    
    mainNav.forEach((n)=>{
        const h=document.querySelector("header").clientHeight;
        n.addEventListener("click",(e)=>{
            e.preventDefault();
            const trg=document.querySelector('[data-pos="'+e.target.dataset.trg+'"]');
            const pos=trg.getBoundingClientRect().top+window.scrollY;
            window.scrollTo({
                top: pos-h*1.5,
                behavior: 'smooth'
            });
            
        });
    });
    document.addEventListener("click", (e)=>{
        const navCheck=document.getElementById("menu-btn-check");
        if (!e.target.closest("header")) {
            if(navCheck.checked){
                navCheck.checked=false;
            }
        }
    });
    document.addEventListener("scroll", (e)=>{
        if(navCheck.checked){
            navCheck.checked=false;
        }
    });
    import(/* webpackChunkName:"assets/js/_positionNav" */'./_positionNav.js').then(PagePositionNav => {
        const Pgn = new PagePositionNav.default();
        Pgn.init();
    });
}

const setMvCal =()=>{
    let vcnt;
    let selPtLi;
    const options = {
        type:'loop',
        mediaQuery: 'max',
        //fixedWidth:"33.33",
        perPage: 3,
        focus: "center",
        perMove:1,
        arrows:false,
        pagination:false,
        waitForTransition:false,
        //gap:"3px",
        autoplay: true,
        interval: 6000,
        speed: 500,
        //padding: "15%",
        pauseOnFocus: false,
        updateOnMove: true,
        breakpoints: {
            767: {
                focus: "center",
                perPage: 1,
                padding: "20%"
            }
        }
    }
    const setMountFunc = ( Splide, Components, options ) => {
        const mount=()=> {
            Splide.on( 'mounted', function () {
                selPtLi.forEach((c)=>{
                    c.addEventListener("click",(e)=>{
                        //e.preventDefault();
                        const tgNo=e.target.closest("li").dataset.no;
                        visCar.go(Number(tgNo));
                    })
                });

                const prvBt=document.querySelector('.mainvis .selPts .arrow.prev');
                const nxtBt=document.querySelector('.mainvis .selPts .arrow.next');
                prvBt.addEventListener('click',(e)=>{
                    visCar.go('<');
                });
                nxtBt.addEventListener('click',(e)=>{
                    visCar.go('>');
                });
                //selPhCal.go('<');
            });
            Splide.on( 'move', function (e) {
                selPtLi.forEach((b)=>{
                    if(b.classList.contains('active')){
                        b.classList.remove('active');
                    }
                });
                selPtLi[e].classList.add('active');
                //console.log(e);
                //selPhCal.go(e);
            });
        }
        return {
            mount,
        };
    }

    const initCar =()=>{
        vcnt=document.querySelectorAll("#main_vis li.splide__slide").length;
        const bts=document.querySelector(".selPts ul");
        let btHtml='';
        for(let i=0;i<vcnt;i++){
            let cls="";
            if(i==0){
                cls='active';
            }
            bts.insertAdjacentHTML('beforeend','<li data-no="'+i+'"><button class="'+cls+'" type="button">'+(i+1)+'</button></li>');
        }
        selPtLi=document.querySelectorAll(".selPts ul li button")
    }

    initCar();
    const visCar=new Splide("#main_vis",options).mount({setMountFunc});
}

const setPrdCal =()=>{
    let pcnt;
    let selPtLi;
    const options = {
        type:'loop',
        mediaQuery: 'max',
        //fixedWidth:"33.33",
        perPage: 4,
        //focus: "center",
        perMove:1,
        arrows:false,
        pagination:false,
        waitForTransition:false,
        //gap:"3px",
        autoplay: true,
        interval: 6000,
        speed: 500,
        //padding: "15%",
        pauseOnFocus: false,
        updateOnMove: true,
        breakpoints: {
            767: {
                focus: "center",
                perPage: 3,
            }
        }
    }
    const setMountFunc = ( Splide, Components, options ) => {
        const mount=()=> {
            Splide.on( 'mounted', function () {
                selPtLi.forEach((c)=>{
                    c.addEventListener("click",(e)=>{
                        //e.preventDefault();
                        const tgNo=e.target.closest("li").dataset.no;
                        prdCar.go(Number(tgNo));
                    })
                });
                
                const prvBt=document.querySelector('.products .prdArrows .prev');
                const nxtBt=document.querySelector('.products .prdArrows .next');
                prvBt.addEventListener('click',(e)=>{
                    prdCar.go('<');
                });
                nxtBt.addEventListener('click',(e)=>{
                    prdCar.go('>');
                });
                
                const prdBt=document.querySelectorAll("#prd_car-list .splide__slide a");
                prdBt.forEach((n)=>{
                    const h=document.querySelector("header").clientHeight;
                    n.addEventListener("click",(e)=>{
                        e.preventDefault();
                        const nth = Number(n.dataset.prd);
                        const trg=document.querySelector(".productCtg ul li:nth-child("+nth+")");
                        const pos=trg.getBoundingClientRect().top+window.scrollY;
                        window.scrollTo({
                            top: pos-h*1.5,
                            behavior: 'smooth'
                        });
                    });
                });
            });
            Splide.on( 'move', function (e) {
                selPtLi.forEach((b)=>{
                    if(b.classList.contains('active')){
                        b.classList.remove('active');
                    }
                });
                selPtLi[e].classList.add('active');
            });
        }
        return {
            mount,
        };
    }

    const initCar =()=>{
        pcnt=document.querySelectorAll("#prd_car li.splide__slide").length;
        const bts=document.querySelector(".selPrdBts ul");
        let btHtml='';
        for(let i=0;i<pcnt;i++){
            let cls="";
            if(i==0){
                cls='active';
            }
            bts.insertAdjacentHTML('beforeend','<li data-no="'+i+'"><button class="'+cls+'" type="button">'+(i+1)+'</button></li>');
        }
        selPtLi=document.querySelectorAll(".selPrdBts ul li button")
    }

    initCar();
    const prdCar=new Splide("#prd_car",options).mount({setMountFunc});
}

const setMov= ()=>{
    const movWrap=document.querySelector("#movWrap");
    const mov=movWrap.querySelector("#movWrap video");
    const play=movWrap.querySelector(".play");
    const pause=movWrap.querySelector(".pause");

    movWrap.addEventListener('click',(e)=>{
        
        if(movWrap.classList.contains('play')){
            mov.pause();
            movWrap.classList.remove('play');
        }else{
            mov.play();
            movWrap.classList.add('play');
        }
    });
    
    mov.addEventListener("ended", (e) => {
        movWrap.classList.remove('play');
    });
}